'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _RatingPoint = require('./RatingPoint.scss');

var _RatingPoint2 = _interopRequireDefault(_RatingPoint);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  RatingPoint: {
    displayName: 'RatingPoint'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/General/RatingPoint/RatingPoint.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var RatingPoint = _wrapComponent('RatingPoint')((_dec = (0, _reactCssModules2.default)(_RatingPoint2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(RatingPoint, _Component);

  function RatingPoint() {
    (0, _classCallCheck3.default)(this, RatingPoint);
    return (0, _possibleConstructorReturn3.default)(this, (RatingPoint.__proto__ || (0, _getPrototypeOf2.default)(RatingPoint)).apply(this, arguments));
  }

  (0, _createClass3.default)(RatingPoint, [{
    key: 'render',
    value: function render() {
      var array = Array(5).fill().map(function (x, i) {
        return i + 1;
      });
      var point = this.props.point;

      return _react3.default.createElement(
        'div',
        { styleName: 'flex-point', style: this.props.center ? { justifyContent: 'center' } : null },
        array.map(function (a) {
          if (point - a >= -0.5) {
            return _react3.default.createElement('i', { key: a, className: 'star-full star-' + a, styleName: 'star' });
          } else if (point - a > -1) {
            return _react3.default.createElement('i', { key: a, className: 'star-half star-' + a, styleName: 'star-h' });
          }
          return _react3.default.createElement('i', { key: a, className: 'star-empty star-' + a, styleName: 'star-o' });
        })
      );
    }
  }]);
  return RatingPoint;
}(_react2.Component), _class2.propTypes = {
  point: _react2.PropTypes.number,
  center: _react2.PropTypes.bool
  // fillBg: PropTypes.bool,
}, _class2.defaultProps = {
  point: 0,
  center: false
  // fillBg: false,

  // getFull = () => {
  //   const point = Math.floor(this.props.point);
  //   const data = [];
  //   for (let i = 0; i < point; i++) {
  //     data.push(<i key={`full-${i}`} className={`star-${i + 1}`} styleName="star"></i>);
  //   }
  //   return data;
  // }
  // getHalf = () => {
  //   const dec = this.props.point - Math.floor(this.props.point);
  //   if (dec > 0 && dec < 0.5) {
  //     return (<i key="half" styleName="star-h"></i>);
  //   } else if (dec >= 0.5) {
  //     return (<i key="half" styleName="star"></i>);
  //   }
  // }
  // getEmpty = () => {
  //   const point = 5 - Math.ceil(this.props.point);
  //   const data = [];
  //   for (let i = 0; i < point; i++) {
  //     data.push(<i key={`empty-${i}`} styleName="star-o"></i>);
  //   }
  //   return data;
  // }
}, _temp)) || _class));

exports.default = RatingPoint;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/General/RatingPoint/RatingPoint.js
// module id = 49
// module chunks = 47